const th = {
  'Language Key': 'th',
  'cui-org-info': 'ข้อมูลองค์กร',
  'cui-sign-on-info': 'เข้าสู่ระบบในข้อมูล',
  'cui-user-info': 'ข้อมูลผู้ใช้',
  'cui-preferences': 'การตั้งค่า',
  'cui-review': 'ทบทวน',
  'cui-org': 'องค์กร',
  'cui-company-division': 'บริษัท / หน่วยงาน',
  'cui-org-address': 'ที่อยู่หน่วยงาน',
  'cui-user-address': 'ที่อยู่ของผู้ใช้',
  'cui-country': 'ประเทศ',
  'cui-city': 'เมือง',
  'cui-state': 'รัฐ / จังหวัด',
  'cui-postal': 'รหัสไปรษณีย์',
  'cui-user-id': 'รหัสผู้ใช้',
  'cui-password': 'รหัสผ่าน',
  'cui-password-re': 'Re: ใส่รหัสผ่าน',
  'cui-challenge-question': 'คำถามท้าทาย',
  'cui-challenge-answer': 'คำตอบที่ท้าทาย',
  'cui-favorite-pet-q': 'ชื่ออะไรสัตว์เลี้ยงที่คุณชื่นชอบ?',
  'cui-mother-q': 'ชื่ออะไรเดิมของคุณแม่ของคุณ?',
  'cui-best-friend-q': 'ใครคือเพื่อนที่ดีที่สุดของคุณ?',
  'cui-first-name': 'ชื่อจริง',
  'cui-last-name': 'นามสกุล',
  'cui-email': 'อีเมล์',
  'cui-email-re': 'ใส่อีเมลอีกครั้ง',
  'cui-telephone': 'หมายเลขโทรศัพท์',
  'cui-timezone': 'เขตเวลา',
  'cui-submit': 'SUBMIT',
  'cui-next': 'ขั้นตอนต่อไป',
  'cui-previous': 'ก่อนหน้านี้',
  'cui-create-security-admin-account': 'สร้างบัญชีผู้ดูแลระบบความปลอดภัยของคุณ',
  'cui-skip-for-now': 'ข้ามไปก่อน',
  'icon-library': 'ห้องสมุดไอคอน',
  'cui-new-TLO': 'องค์การระดับสูงสุดใหม่',
  'cui-new-TLO-description': 'เลือกวิธีการนี้หากคุณต้องการที่จะเข้าร่วมแลกเปลี่ยน Covisint เป็นองค์การ Covisint ใหม่',
  'cui-new-division': 'กองใหม่',
  'cui-new-division-description-start': 'เลือกวิธีการนี้หากคุณต้องการที่จะกลายเป็น',
  'cui-new-division-description-end': 'ของแผนกใหม่ภายในองค์การ Covisint ที่มีอยู่',
  'cui-security-administrator': 'ผู้ดูแลระบบรักษาความปลอดภัย',
  'cui-new-user': 'ผู้ใช้ใหม่',
  'cui-new-user-description': 'เลือกวิธีนี้ถ้าคุณเป็นพนักงานของ บริษัท Covisint สมาชิกที่มีอยู่การเข้าถึงที่กำลังมองหาเพื่อการประยุกต์ใช้ในองค์กรของคุณสมัครหรือถ้าคุณไม่แน่ใจว่าองค์กรของคุณจดทะเบียน',
  'cui-sign-up': 'ลงชื่อ',
  'cui-address': 'ที่อยู่',
  'cui-organization-name': 'บริษัท / หน่วยงาน',
  'cui-supplier-code': 'รหัสผู้จัดจำหน่าย',
  'cui-address-1': 'ที่อยู่ 1',
  'cui-address-2': 'ที่อยู่ 2',
  'cui-user-information': 'ข้อมูลผู้ใช้',
  'cui-organization-information': 'ข้อมูลองค์กร',
  'cui-sign-in-information': 'เข้าสู่ระบบข้อมูล',
  'cui-package-selection': 'เลือกแพ็กเกจ',
  'cui-welcome-popover': 'ความรับผิดชอบของการรักษาความปลอดภัยของผู้ดูแลระบบจะได้รับการอธิบายในรายละเอียดหลังจากที่คุณเลือกวิธีการลงทะเบียน แต่คุณอาจเลือกที่จะยกเลิกการลงทะเบียนของคุณเพื่อให้เป็นสมาชิกที่แตกต่างกันของ Organiziation ของคุณเพื่อลงทะเบียนเป็นผู้ดูแลรักษาความปลอดภัย',
  'create-account': 'สร้างบัญชีของคุณ',
  'cui-agree-covisint': 'ผมเห็นด้วยกับ Covisint',
  'terms-of-service': 'เงื่อนไขการให้บริการ',
  'cui-and': 'และ',
  'privacy-policy': 'นโยบายความเป็นส่วนตัว',
  'cui-tos-agree': 'คุณต้องยอมรับข้อตกลงในการให้บริการเพื่อดำเนินการต่อ',
  'cui-user-profile': 'ประวัติผู้ใช้',
  'cui-my-profile': 'ประวัติของฉัน',
  'cui-login': 'เข้าสู่ระบบ',
  'cui-supplier-content': 'อัปเดตครั้งนี้เอกสารการออกแบบมาใน. นี้อยู่ในเอกสารการแปลของ Google Lorem Ipsum อย่างอื่น. รหัสผู้จำหน่ายข้อมูลที่สำคัญ ฉันชอบเต่า.',
  'cui-all-organizations': 'องค์กรทั้งหมด:',
  'cui-application-select-info': 'คุณสามารถทำให้การเลือกของคุณหลังจากเข้าสู่ระบบเป็นครั้งแรก',
  'cui-all-applications': 'การใช้งานทั้งหมด',
  'cui-page-not-found': 'ไม่พบหน้านี้',
  'cui-page-not-found-content': 'หน้าเว็บที่คุณกำลังมองหาอาจถูกลบหรือไม่เคยมีชีวิตอยู่',
  'cui-home': 'บ้าน',
  'cui-access-denied': 'ปฏิเสธการเข้าใช้',
  'cui-access-denied-content': 'คุณยังไม่ได้รับอนุญาตให้ดูหน้านี้',
  'cui-registration-status': 'สถานะการลงทะเบียน',
  'cui-pending-status': 'รอดำเนินการสถานะ',
  'cui-pending-status-content': 'สถานะการลงทะเบียนของคุณยังคงอยู่ระหว่างดำเนินการ คุณจะได้รับอีเมลที่มีรายละเอียดมากขึ้นในไม่ช้า',
  'cui-thank-you': 'ขอขอบคุณ',
  'cui-request-submitted': 'ส่งคำขอ',
  'cui-success': 'ความสำเร็จ',
  'cui-success-content': 'การลงทะเบียน Covisint ของคุณได้ถูกส่งเรียบร้อยแล้ว คุณจะได้รับอีเมลที่มีรายละเอียดมากขึ้นในไม่ช้า',
  'cui-check-your': 'ตรวจสอบ .. ของคุณ',
  'cui-registration-status-lower': 'สถานะการลงทะเบียน',
  'cui-application-selection': 'แอพลิเคชันการเลือก',
  'cui-applications': 'การประยุกต์ใช้งาน',
  'cui-profile-settings': 'การตั้งค่าโปรไฟล์',
  'cui-name': 'ชื่อ',
  'cui-update': 'ปรับปรุง',
  'cui-updated': 'Updated',
  'cui-error-try-again': 'ข้อผิดพลาด! ลองอีกครั้ง?',
  'cui-back': 'กลับ',
  'cui-selections': 'เลือก',
  'cui-add-org': 'เพิ่มองค์การ',
  'cui-remove-org': 'นำองค์การ',
  'cui-select-org': 'เลือกองค์การ',
  'cui-more-information': 'ข้อมูลมากกว่านี้',
  'cui-inv-user-popover-info': 'สำหรับเหตุผลด้านความปลอดภัยคุณจะต้องลงทะเบียนกับทาง e-mail ของคุณเชิญที่ถูกส่ง นี้สามารถแก้ไขได้ในการตั้งค่าผู้ใช้เมื่อลงทะเบียนเสร็จสมบูรณ์',
  'cui-org-profile': 'รายละเอียดองค์กร',
  'cui-info': 'ข้อมูล',
  'cui-admins': 'ผู้ดูแลระบบ',
  'lowercase-not-allowed': 'ไม่ได้มีตัวอักษรกรณีใด ๆ ที่ต่ำ',
  'uppercase-not-allowed': 'ไม่ได้มีตัวอักษรพิมพ์ใหญ่ใด ๆ',
  'numbers-not-allowed': 'ไม่ได้มีตัวเลขใด ๆ',
  'special-not-allowed': 'ไม่ได้มีสัญลักษณ์พิเศษใด ๆ (เช่น:! * +)',
  'chars-not-allowed': 'ไม่มีอักขระต่อไปนี้: {{disallowedChars}}',
  'words-not-allowed': 'ไม่ไมีคำต่อไปนี้: {{disallowedWords}}',
  'password-length': 'มีความยาว {{min}}-{{max}} ตัวอักษร',
  'password-rules': 'มี {{requiredNumberOfCharClasses}} สิ่งต่อไปนี้:',
  'password-lowercase': 'อย่างน้อย 1 ตัวอักษรกรณีที่ต่ำกว่า',
  'password-uppercase': 'อย่างน้อย 1 ตัวอักษรตัวพิมพ์ใหญ่',
  'password-number': 'อย่างน้อย 1 หมายเลข',
  'password-special': 'อย่างน้อย 1 สัญลักษณ์พิเศษ (เช่น:! * +)',
  'passwords-must': 'รหัสผ่านต้อง:',
  'welcome-title': 'ลงทะเบียนสำหรับการอย่างใดอย่างหนึ่งดังต่อไปนี้',
  'cui-application-name': 'ชื่อโปรแกรมประยุกต์',
  'cui-application-tos': 'ทบทวนข้อตกลงและเงื่อนไข',
  'cui-application-tos-agreement': 'ข้อตกลงและเงื่อนไขข้อตกลง',
  'cui-package-tos': 'คุณยังไม่ได้ยอมรับเงื่อนไขสำหรับแพคเกจที่เลือก',
  'cui-view-tos': 'ดูข้อตกลงและเงื่อนไข',
  'password-mismatch': 'รหัสผ่านต้องตรงกัน',
  'cui-back-to-review': 'กลับไปทบทวน',
  'email-mismatch': 'อีเมลจะต้องตรงกับ',
  'no-applications-selected': 'คุณไม่ได้มีการใช้งานที่เลือก คลิกที่นี่เพื่อกลับไปที่ตัวเลือกการประยุกต์ใช้',
  'cui-all-fields-required': 'ต้องระบุทุกช่อง',
  'cui-complete-registration': 'เสร็จสิ้นการลงทะเบียนของคุณด้านล่างด้วย',
  'cui-registered': 'ลงทะเบียน',
  'cui-open': 'เปิด',
  'cui-close': 'ปิด',
  'cui-street-address': 'ที่อยู่ถนน',
  'cui-zip': 'ซิป',
  'cui-language': 'ภาษา',
  'cui-phone-main': 'หลัก',
  'cui-phone-office': 'สำนักงาน',
  'cui-phone-fax': 'โทรศัพท์ / แฟกซ์',
  'cui-phone-mobile': 'โทรศัพท์มือถือ',
  'cui-save': 'บันทึก',
  'cui-cancel': 'ยกเลิก',
  'cui-edit': 'แก้ไข',
  'cui-phone': 'โทรศัพท์',
  'search-by-app-name': 'ค้นหาตามชื่อแอพลิเคชัน',
  'new-request': 'คำขอใหม่',
  'select-applications': 'เลือก Applications',
  'browse-applications': 'เรียกดูการประยุกต์ใช้งาน',
  'go': 'ไป',
  'filter-list': 'รายการตัวกรอง',
  'filter': 'กรอง',
  'owning-org': 'การเป็นเจ้าขององค์กร',
  'my-applications': 'การประยุกต์ใช้งานของฉัน',
  'app-summary': 'App อย่างย่อ',
  'granted': 'ที่ได้รับ',
  'bundled-applications': 'การประยุกต์ใช้งานแถม',
  'application-details': 'รายละเอียดการสมัคร',
  'my-claims': 'การเรียกร้องของฉัน',
  'related-applications': 'ประยุกต์ใช้ที่เกี่ยวข้อง',
  'review-request': 'ตรวจสอบคำขอ',
  'back-to-search': 'กลับไปที่ค้นหา',
  'requested-items': 'รายการที่ขอ',
  'request-reason': 'ที่ขอเหตุผล',
  'reason-im-requesting': 'เหตุผลที่ฉันขอ',
  'you-must-enter-a-reason': 'คุณต้องใส่เหตุผลที่จะขอ app นี้',
  'cui-org-no-applications': 'ดูเหมือนว่าองค์กรของคุณไม่ได้มีการใช้งานใด ๆ คุณสามารถลองอีกครั้งหลังจากเข้าสู่ระบบ',
  'cui-filter-org-name': 'กรองตามชื่อองค์กร',
  'cui-address-example': 'พาร์ทเมนต์, ห้อง, ตึก (ไม่จำเป็น)',
  'cui-filter-app-name': 'กรองตามชื่อโปรแกรมประยุกต์',
  'cui-search-user-name': 'ผู้ใช้ค้นหาตามชื่อ',
  'page': 'หน้า',
  'cui-num-results-page': 'ผลลัพธ์ต่อหน้า',
  'submit-request': 'ส่งคำขอ',
  'categories': 'หมวดหมู่',
  'cui-answer': 'ตอบ',
  'cui-enter-password': 'ใส่รหัสผ่าน',
  'cui-enter-new-password': 'ใส่รหัสผ่านใหม่',
  'cui-re-enter-new-password': 'ป้อนรหัสผ่านใหม่',
  'granted-to-my-org': 'มอบให้แก่องค์กรของฉัน',
  'collected-items-for-request': 'รายการที่เก็บไว้สำหรับการร้องขอ',
  'cui-invalid-password': 'รหัสผ่านไม่ถูกต้อง. กรุณาลองอีกครั้ง.',
  'cui-faq': 'คำถามที่พบบ่อย',
  'cui-frequently-asked-questions': 'คำถามที่พบบ่อย',
  'cui-admin-tools': 'เครื่องมือบริหารระบบ',
  'cui-this-field-is-required': 'ฟิลด์นี้จะต้อง',
  'cui-this-field-needs-to-be-longer': 'ข้อมูลนี้จะต้องมีอีกต่อไป',
  'cui-you-need-to-agree-to-toc': 'คุณจำเป็นต้องยอมรับข้อตกลงในการให้บริการก่อนที่คุณจะดำเนินการต่อไป',
  'cui-this-is-not-valid-email': 'นี้ไม่ได้เป็นอีเมลที่ถูกต้อง',
  'cui-my-app-requests': 'แอพลิเคชันการร้องขอของฉัน',
  'cui-no-claims': 'คุณมีการเรียกร้องสำหรับโปรแกรมนี้ไม่มี',
  'cui-no-details': 'ไม่มีรายละเอียด',
  'request': 'ขอร้อง',
  'all': 'ทั้งหมด',
  'no-selected-apps': 'คุณยังไม่ได้เลือกการใช้งานใด ๆ',
  'basic-info': 'ข้อมูลพื้นฐาน',
  'cui-error-username-exists': 'รหัสผู้ใช้อยู่แล้ว! โปรดเลือกอีกหนึ่ง',
  'password-reset': 'รีเซ็ตรหัสผ่าน',
  'current-password': 'รหัสผ่านปัจจุบัน',
  'timezone-and-language': 'เขตเวลาและภาษา',
  'challenge-questions': 'คำถามที่ท้าทาย',
  'security-question-repeated': 'คำตอบนี้ได้ถูกนำมาใช้แล้ว',
  'cui-by-date-added': 'เพิ่มเมื่อวันที่',
  'cui-alphabetically': 'ตามตัวอักษร',
  'active': 'คล่องแคล่ว',
  'pending': 'รอดำเนินการ',
  'suspended': 'ที่ถูกระงับ',
  'title': 'หัวข้อ',
  'id': 'ID',
  'url': 'url',
  'privacy-terms': 'ความเป็นส่วนตัวและข้อตกลง',
  'help': 'ช่วยด้วย',
  'cui-learn-more-start': 'เรียนรู้เพิ่มเติม',
  'cui-learn-more-end': 'เกี่ยวกับเหตุผลที่เราขอข้อมูลนี้',
  'cui-org-hierarchy': 'องค์การลำดับชั้น',
  'directory': 'ไดเรกทอรี',
  'userID': 'รหัสผู้ใช้',
  'status': 'สถานะ',
  'locked': 'ล็อค',
  'rejected': 'ปฏิเสธ',
  'removed': 'ลบออก',
  'sort': 'ประเภท',
  'refine': 'ปรับแต่ง',
  'or': 'หรือ',
  'organizations': 'องค์กร',
  'roles': 'บทบาท',
  'organization-applications': 'การประยุกต์ใช้งานขององค์กร',
  'unactivated': 'กระตุ้น',
  'log-out': 'ออกจากระบบ',
  'welcome': 'ยินดีต้อนรับ',
  'privacy': 'ความเป็นส่วนตัว',
  'terms': 'ข้อตกลงและเงื่อนไข',
  'user': 'ผู้ใช้งาน',
  'top-level-orgs': 'องค์กรระดับบนสุด',
  'invite-user': 'เชิญผู้ใช้',
  'invite-division': 'เชิญกอง',
  'username': 'ชื่อผู้ใช้',
  'move': 'ย้าย',
  'no-bundled-or-related': 'ไม่มีแอปที่รวมหรือสาขาที่เกี่ยวข้อง',
  'cui-continue': 'ต่อ',
  'cui-no-org-divisions': 'ไม่มีส่วนขององค์กร',
  'inactive': 'เฉื่อยชา',
  'deny': 'ปฏิเสธ',
  'approve': 'อนุมัติ',
  'pending-request': 'การร้องขอที่ค้าง',
  'review-approvals': 'การอนุมัติการทบทวน',
  'cui-package-no-claims': 'แพคเกจนี้มีการเรียกร้องไม่',
  'claims': 'การเรียกร้อง',
  'package-name': 'ชื่อแพ็กเกจ',
  'submit-approvals': 'ส่งการอนุมัติ',
  'view-details': 'ดูรายละเอียด',
  'request-date': 'คำขอวัน',
  'registration-decision': 'การตัดสินใจที่ลงทะเบียน',
  'requested': 'การขอใช้บริการ',
  'getting-user-info': 'ได้รับข้อมูลของผู้ใช้ของคุณ ...',
  'approvals-submitted': 'อนุมัติ Submitted',
  'rejection-submitted': 'ปฏิเสธส่ง',
  'approval-summary': 'ได้รับการอนุมัติอย่างย่อ',
  'approved-items': 'รายการที่ได้รับการอนุมัติ',
  'rejected-items': 'รายการที่ถูกปฏิเสธ',
  'registration-request-approved': 'คำขอลงทะเบียนรับการอนุมัติ',
  'registration-request-rejected': 'คำขอลงทะเบียนที่ถูกปฏิเสธ',
  'no-items-rejected': 'ไม่มีรายการปฏิเสธ',
  'no-items-approved': 'ไม่มีรายการที่ได้รับการอนุมัติ',
  'registration-request': 'ขอลงทะเบียน',
  'custom-api-loading': 'เริ่มต้น app ...',
  'new-grant': 'ให้แอป',
  'search-by-package-name': 'ค้นหาตามชื่อแพคเกจ',
  'search': 'ค้นหา',
  'administartor-?': 'ผู้ดูแลระบบ?',
  'submit-grant-update': 'ส่งการอัปเดทุน',
  'review-user-pending-approval': 'วิจารณ์จากผู้ใช้รอการอนุมัติ',
  'view-request-for': 'ขอดู',
  'job-title': 'ตำแหน่งงาน',
  'query': 'สอบถาม',
  'suspend-app': 'ระงับ App',
  'new-grants': 'แกรนต์ใหม่',
  'update-grant-settings': 'การตั้งค่าการปรับปรุงแกรนท์',
  'assign-new-grant-to': 'กำหนดทุนใหม่เพื่อ',
  'division': 'แผนก',
  'redirecting-to-sso': 'การขอข้อมูลประจำตัวของคุณ',
  'included-applications': 'รวมถึงการประยุกต์ใช้งาน',
  'selected-sub-packages': 'เลือกตำบลแพคเกจ',
  'specify-password': 'ระบุรหัสผ่าน',
  'suspend': 'แขวน',
  'reset-password': 'รีเซ็ตรหัสผ่าน',
  'confirm-password-reset': 'คุณแน่ใจหรือไม่ว่าต้องการรีเซ็ตรหัสผ่านสำหรับผู้ใช้รายนี้',
  'yes': 'ใช่',
  'within': 'ภายใน',
  'search-within': 'ค้นหาภายใน',
  'in-your-org': 'ในองค์กรของคุณ',
  'people': 'คน',
  'revoke-package': 'ยกเลิกการแพคเกจ',
  'cui-by-username': 'ชื่อผู้ใช้',
  'cui-by-status': 'สถานะ',
  'cool-got-it': 'เย็นได้รับมัน',
  'organization-directory': 'ไดเรกทอรีองค์การ',
  'org-nav-invite-links': 'องค์การนำร่องและลิงค์เชิญ',
  'org-dir-filters': 'กรองไดเรกทอรีองค์การ',
  'org-dir-list': 'องค์การรายการไดเรกทอรี',
  'apps': 'ปพลิเคชัน',
  'apps-upper': 'แอพพลิเคชัน',
  'history-upper': 'ประวัติศาสตร์',
  'profile-upper': 'ข้อมูลส่วนตัว',
  'roles-upper': 'บทบาท',
  'your-app-request-in-review': 'ขอใบสมัครของคุณถูกส่ง',
  'error-generic': 'มีปัญหาในการโหลดข้อมูลในหน้านี้คือ กรุณาลองอีกครั้ง.',
  'cui-application-administrator': 'ไม่ได้ในขณะนี้มีบทบาทของผู้ดูแลระบบแอพลิเคชันซึ่งจะต้องได้รับมอบหมายก่อนที่ผู้ใช้จะได้รับสิทธิในการบริหารสำหรับการใช้งานที่กำหนด นี่คือการตั้งค่าครั้งเดียว',
  'cui-assign-confirm': 'คุณต้องการที่จะกำหนดบทบาทในตอนนี้?',
  'cui-suspend-warning': 'จะไม่สามารถเข้าถึงโปรแกรมนี้',
  'cui-suspend-confirm': 'คุณแน่ใจหรือไม่ต้องการที่จะระงับตอนนี้หรือไม่',
  'cui-notify-user': 'แจ้งให้ผู้ใช้',
  'cui-users': 'ผู้ใช้',
  'cui-no': 'ไม่',
  'cui-remove': 'ลบออก',
  'cui-org-abbrev': 'องค์กร',
  'cui-userProfile-user-error': 'เกิดข้อผิดพลาดในการเรียกข้อมูลของผู้ใช้เป็น กรุณาลองอีกครั้ง.',
  'cui-userProfile-security-error': 'เกิดข้อผิดพลาดในการเรียกข้อมูลคำถามการรักษาความปลอดภัย กรุณาลองอีกครั้ง.',
  'cui-userProfile-password-error': 'มีข้อผิดพลาดข้อมูลนโยบายการเรียกรหัสผ่านคือ กรุณาลองอีกครั้ง.',
  'cui-suspend-success': 'โปรแกรมนี้จะถูกระงับในขณะนี้จากผู้ใช้ที่เลือก',
  'cui-unlock': 'ปลดล็อค',
  'cui-unlock-password-confirm': 'คุณแน่ใจหรือว่าคุณต้องการที่จะปลดล็อครหัสผ่านของผู้ใช้นี้?',
  'cui-error-unlocking-password': 'ขออภัยมีข้อผิดพลาดในการปลดล็อครหัสผ่านของผู้ใช้นี้',
  'cui-error-person-request': 'ไม่สามารถดึงข้อมูลการร้องขอการลงทะเบียนสำหรับผู้ใช้นี้',
  'cui-error-email-exists': 'ที่อยู่อีเมล์ได้มีการดำเนินการ',
  'cui-password-history-rule': 'ไม่ตรงกับที่ก่อนหน้านี้ {{}} numberOfPasswords รหัสผ่านของคุณ',
  'cui-password-policy': 'นโยบายรหัสผ่าน',
  'cui-security-admin': 'ดูแลระบบความปลอดภัย',
  'cui-button-loading-text': 'กำลังโหลด ...',
  'cui-username-taken': 'ชื่อผู้ใช้งานจะได้รับการ',
  'cui-no-applications': 'ขณะนี้คุณมีการใช้งานไม่มี',
  'cui-mask-answers': 'หน้ากากคำตอบการรักษาความปลอดภัย / เปิดโปง',
  'cui-pwd-reset-success': 'ตั้งรหัสผ่านใหม่ที่ประสบความสำเร็จ!',
  'cui-last-login': 'เข้าสู่ระบบล่าสุด',
  'cui-need-different-app': 'จำเป็นต้องใช้โปรแกรมที่แตกต่างกัน',
  'cui-go-back-to': 'กลับไป',
  'cui-tos-applications': 'โปรดยอมรับข้อตกลงและเงื่อนไขสำหรับการใช้งานที่เลือก',
  'cui-selected-apps': 'การประยุกต์ใช้งานที่เลือก',
  'cui-authentication-policy': 'นโยบายการตรวจสอบสิทธิ์',
  'cui-selected': 'เลือก',
  'cui-tac': 'ข้อตกลงและเงื่อนไข',
  'cui-accept': 'ยอมรับ',
  'cui-tac-agree': 'คุณต้องยอมรับข้อตกลงและเงื่อนไขเพื่อดำเนินการต่อ',
  'cui-printer-friendly-tac': 'ข้อตกลงและเงื่อนไขที่เหมาะสำหรับพิมพ์',
  'cui-my-history': 'ประวัติศาสตร์ของฉัน',
  'cui-status-history': 'ประวัติสถานะของฉัน',
  'cui-app-history': 'ประวัติการสมัครงานออนไลน์',
  'cui-password-change-log': 'บันทึกการเปลี่ยนแปลงรหัสผ่าน',
  'cui-date': 'วันที่',
  'cui-event-type': 'ชนิดเหตุการณ์',
  'cui-action-by': 'การดำเนินการดำเนินการโดย',
  'cui-notes': 'หมายเหตุ',
  'cui-try-again': 'กรุณาลองอีกครั้ง.',
  'cui-password-change-log-error': 'มีการบันทึกการเปลี่ยนแปลงรหัสผ่านข้อผิดพลาดในการเรียกเป็น',
  'cui-userstatus-history-error': 'มีข้อผิดพลาดประวัติสถานะของผู้ใช้เรียกเป็น',
  'cui-claims-error': 'เกิดข้อผิดพลาดในการเรียกเรียกร้องเป็น',
  'cui-org-app-suspend-success': 'โปรแกรมนี้จะถูกระงับในขณะนี้จากองค์กรที่เลือกผู้ใช้ทั้งหมดและองค์กรย่อยทั้งหมด',
  'cui-org-app-suspend-msg1': 'การดำเนินการนี้จะระงับการดำเนินการจากผู้ใช้และองค์กรย่อยแม้ในขณะที่ในการใช้งานที่ใช้งาน',
  'cui-org-app-suspend-msg2': 'คุณแน่ใจหรือไม่ว่าคุณต้องการที่จะระงับ',
  'cui-from': 'จาก',
  'cui-application-granted-history': 'ใบสมัครทุนประวัติศาสตร์',
  'cui-application-requested-history': 'แอพลิเคชันที่ขอประวัติ',
  'approved': 'ได้รับการอนุมัติ',
  'decision': 'การตัดสิน',
  'evaluator': 'ประเมิน',
  'action': 'การกระทำ',
  'cui-invalid-invitation': 'ขอเชิญเป็นทั้งที่ใช้แล้วหรือไม่ถูกต้อง',
  'cui-by-request-date': 'คำขอวัน',
  'cui-by-decision-date': 'วันที่ตัดสินใจ',
  'cui-no-orgs-for-name': 'ไม่พบชื่อที่ระบุในองค์กร โปรดลองมีชื่อที่แตกต่างกัน',
  'requests': 'การร้องขอ',
  'no-pending-apps': 'คุณไม่มีคำขอแอพลิเคชันที่รอดำเนินการ',
  'description': 'ลักษณะ',
  'launch': 'เปิด',
  'manage-applications': 'จัดการโปรแกรมประยุกต์',
  'request-type': 'ชนิดของการร้องขอ',
  'phase': 'ระยะ',
  'date-submitted': 'วันที่ส่ง',
  'cui-pending-requests-error': 'เกิดข้อผิดพลาดในการเรียก / คำขอปรับปรุงเป็น',
  'no-requests-by-name': 'ไม่พบชื่อที่ระบุการร้องขอ โปรดลองมีชื่อที่แตกต่างกัน',
  'cannot-change-password': 'ไม่สามารถเปลี่ยนรหัสผ่านในขณะนี้',
  'select-claims': 'เลือกการเรียกร้อง',
  'grant-reason': 'แกรนท์เหตุผล',
  'grants-assigned': 'แกรนต์ใหม่ที่ได้รับมอบหมาย',
  'suspend-error': 'เกิดข้อผิดพลาดในการระงับการร้องขอเป็น',
  'unsuspend-error': 'เกิดข้อผิดพลาดในคำขอยกเลิกการระงับเป็น',
  'approval': 'การอนุมัติ',
  'administrator': 'ผู้บริหาร',
  'submitted': 'ส่ง',
  'no-bundled': 'ไม่มีแอปรวม',
  'disallowed-password-rule': 'ไม่สามารถมีคำไม่ได้รับอนุญาตในรายการคำ',
  'request-approve-or-rejected': 'คำขอนี้ได้รับการอนุมัติอย่างใดอย่างหนึ่ง / ปฏิเสธ',
  'application': 'ใบสมัคร',
  'show-all': 'แสดงทั้งหมด',
  'cui-subject': 'เรื่อง',
  'cui-es': '(e)',
  'cui-invite-user': 'เชิญผู้ใช้ภายใน',
  'cui-invite-user-success': 'คำขอเชิญผู้ใช้ของคุณส่ง',
  'cui-email-recipt': 'ใส่อีเมลของผู้รับ (หลายแยกต่างหากด้วยเครื่องหมายจุลภาค)',
  'cui-invite-verbiage': 'เชิญอย่างใดอย่างหนึ่งดังต่อไปนี้',
  'select': 'เลือก',
  'change-org': 'เปลี่ยนองค์กร',
  'cui-invite-user-sub': 'ลงทะเบียนเป็นผู้ใช้ที่จะเข้าร่วม',
  'cui-invite-user-select': 'ค้นหาสำหรับองค์กร',
  'cui-send-invitation': 'ส่งคำเชิญชวน',
  'invite': 'เชิญ',
  'cui-invite-tlo-success': 'ระดับบนสุดของคำเชิญขององค์กรของคุณส่ง',
  'cui-invite-tlo': 'เชิญองค์กรใหม่',
  'cui-invite-division-success': 'คำเชิญ บริษัท ของคุณส่ง',
  'cui-invite-division': 'เชิญชวนองค์กร',
  'cui-tlo-sub': 'ลงทะเบียนเป็นองค์กรใหม่',
  'cui-division-sub': 'ลงทะเบียนเป็นผู้ดูแลระบบภายใน',
  'search-by-org-name': 'ค้นหาตามชื่อองค์กร',
  'app-approval-error': 'เกิดข้อผิดพลาดในการอนุมัติการร้องขอ App เป็น',
  'modify-claims': 'ปรับเปลี่ยนการเรียกร้อง',
  'unsuspend-app': 'ยกเลิกการระงับ App',
  'remove-app': 'ลบ App',
  'user-details': 'รายละเอียดผู้ใช้',
  'reason': 'เหตุผล',
  'required': 'จำเป็นต้องใช้',
  'cui-unsuspend-confirm': 'คุณแน่ใจหรือต้องการยกเลิกการระงับตอนนี้หรือไม่',
  'unsuspend': 'ยกเลิกการระงับ',
  'remove-confirm': 'คุณแน่ใจหรือคุณต้องการที่จะลบตอนนี้หรือไม่',
  'remove': 'เอาออก',
  'my-organization': 'องค์กรของฉัน',
  'request-app': 'คำขอ App',
  'no-apps-found': 'ไม่พบการใช้งาน',
  'refine-search': 'โปรดปรับแต่งเกณฑ์การค้นหาของคุณ',
  'your-assign-role-success': 'บทบาทใหม่ที่ได้รับมอบหมาย',
  'cui-assigned-roles': 'บทบาทที่ได้รับมอบหมาย',
  'cui-available-roles': 'บทบาทที่มีอยู่',
  'cui-browse-by-category': 'ดูตามหมวดหมู่',
  'cui-back-navigation-requests': 'นำทางกลับและคำขอ',
  'cui-search-results': 'ผลการค้นหา',
  'cui-new-grant-search-results': 'แกรนท์ใหม่ผลการค้นหา',
  'cui-username-close': 'ชื่อผู้ใช้และการนำทางใกล้',
  'cui-user-no-apps': 'ผู้ใช้มีการใช้งานไม่มี',
  'cui-no-roles-assigned': 'ผู้ใช้รายนี้ได้มอบหมายบทบาทไม่มี',
  'status-history': 'ประวัติสถานะ',
  'cui-no-status-history': 'ผู้ใช้รายนี้มีประวัติสถานะไม่มี',
  'cui-pwd-reset-msg1': 'รีเซ็ตรหัสผ่านจะประสบความสำเร็จ รหัสผ่านใหม่:',
  'cui-pwd-reset-msg2': 'หมายเหตุ: หากคุณจะเห็นเพียงครั้งแรกที่ใช้รหัสผ่านครึ่งแล้วครึ่งหนึ่งรหัสผ่านที่สองจะถูกส่งไปยังผู้ใช้ที่ลงทะเบียนอีเมล',
  'users-upper': 'ผู้ใช้',
  'hierarchy-upper': 'ลำดับชั้น',
  'privileges': 'สิทธิพิเศษ',
  'expand-all': 'ขยายทั้งหมด',
  'collapse-all': 'ยุบทั้งหมด',
  'no-records': 'ไม่มีบันทึกที่ค้นพบ',
  'contact-us': 'ติดต่อเรา',
  'cui-error-organization-request': 'ไม่สามารถดึงข้อมูลการร้องขอการลงทะเบียนสำหรับองค์กรนี้',
  'cui-error-organization-app-request': 'ไม่สามารถดึงข้อมูลการร้องขอ app สำหรับองค์กรนี้',
  'cui-error-user-app-request': 'ไม่สามารถดึงข้อมูลการร้องขอแอปสำหรับผู้ใช้นี้',
  'assign': 'กำหนด',
  'search-by-person-name': 'ค้นหาตามชื่อของบุคคล',
  'grant-history': 'ประวัติแกรนท์',
  'request-history': 'ประวัติคำขอ',
  'social-login': 'เข้าสู่ระบบสังคม',
  'facebook': 'Facebook',
  'twitter': 'พูดเบาและรวดเร็ว',
  'link': 'ลิงค์',
  'unlink': 'ยกเลิกการเชื่อมโยง',
  'invalid-url': 'นี้ไม่ได้เป็น URL ที่ถูกต้อง',
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'การบริหาร',
  'services': 'บริการ',
  'n-phase': 'N - อนุมัติเฟส',
  'edit-package': 'แก้ไขแพคเกจ',
  'is-requestable': 'คือ Requestable',
  'is-displayable': 'คือสามารถแสดง',
  'is-grantable': 'คือ Grantable',
  'require': 'จำเป็นต้อง',
  'is-requestable-desc': 'ระบุว่าผู้ใช้สามารถขอโปรแกรมนี้',
  'is-grantable-desc': 'ระบุว่าโปรแกรมนี้จะได้รับโดยตรงจากการบริหารงานของ บริษัท ให้กับผู้ใช้',
  'is-displayable-desc': 'แสดงให้เห็นว่าไอคอนแพคเกจควรจะปรากฏในหน้างานของฉัน',
  'require-reason-desc': 'ระบุว่าแพคเกจนี้ผู้ใช้ต้องให้เหตุผลในการขอแพคเกจนี้',
  'company-admin': 'บริษัท ผู้ดูแลระบบ',
  'application-admin': 'แอพลิเคชันผู้ดูแลระบบ',
  'company-admin-desc': 'นี่คือขั้นตอนการอนุมัติเริ่มต้นก็ควรจะใช่ถ้าไม่มีขั้นตอนอื่น ๆ ที่จำเป็น',
  'application-admin-desc': 'ไม่แอพลิเคชันที่ผู้ใช้ร้องขอความต้องการที่จะได้รับการอนุมัติโดยผู้ดูแลระบบใบสมัคร',
  'add-admins': 'เพิ่มผู้ดูแลระบบ',
  'cardinality-indicator': 'cardinality ดัชนี',
  'cui-one': 'หนึ่ง',
  'cui-many': 'จำนวนมาก',
  'claim-values': 'ค่าเรียกร้อง',
  'cui-add': 'เพิ่ม',
  'cui-view': 'ดู',
  'cui-claim': 'ข้อเรียกร้อง',
  'cui-category': 'ประเภท',
  'cui-service': 'บริการ',
  'cui-delete': 'ลบ',
  'federation-conn': 'การเชื่อมต่อสภา',
  'updated-date': 'วันที่ปรับปรุง',
  'target-url': 'URL เป้าหมาย',
  'remote-app-id': 'การประยุกต์ใช้รหัสระยะไกล',
  'mobile-sso-url': 'URL SSO มือถือ',
  'mobile-app-id': 'Mobile App ID',
  'cui-package': 'บรรจุภัณฑ์',
  'cui-create': 'สร้าง',
  'more-languages': 'ภาษาอื่น ๆ',
  'duplicate-language-error': 'ภาษาที่ซ้ำกันจะไม่ได้รับอนุญาต',
  'cui-nextstep': 'ต่อไป',
  'create-package': 'สร้างแพคเกจ',
  'manage-package-claims': 'จัดการแพคเกจการเรียกร้อง',
  'cardinality-indicator-error': 'cardinality ดัชนีไม่สามารถเป็นหนึ่ง',
  'value-id-exists': 'รหัสค่าอยู่แล้ว',
  'claim-id-exists': 'Id เรียกร้องอยู่แล้ว',
  'cui-new': 'ใหม่',
  'package-success-content': 'แพคเกจสร้างเสร็จเรียบร้อยแล้ว',
  'add-claims': 'เพิ่มการเรียกร้อง',
  'package-update-success': 'แพคเกจการปรับปรุงเรียบร้อยแล้ว'
}

export {
  th
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/th.js